var Waypoints = (function () {

    var $ = require('jquery');
    var self = {};

    self.block = App.Globals.$body.find('.block, .content-item, .banner');

    self.init = function () {

        if (self.block.length > 0) {

            require('./../../../../build/node_modules/@components/waypoints/lib/jquery.waypoints.js');

            self.block.waypoint(function (direction) {

                var $el = $(this.element);

                if (direction === 'down') {
                    $el.addClass('animate');
                }

            }, {
                offset: '80%'
            });

        }

    };

    return self;

}());

module.exports = Waypoints;
